:host {
  display: block;
}

.energy-label {
  position: relative;
  display: inline-block;
  width: 35px;
  height: auto;
  cursor: pointer;

  img {
    vertical-align: middle;
  }

  &.no-tooltip {
    pointer-events: none;
  }

  @include breakpointMin('md') {
    width: 50px;
  }

  &.detail-page {
    width: 55px;
  }

  lilu-energy-tooltip {
    display: none;
  }
}
